module.exports = __webpack_public_path__ + "public/img/yibiaopan_lan_40.f82281ca.png";